import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import { Inter, Hanken_Grotesk } from 'next/font/google'

const inter = Inter({
    variable: '--font-sans',
    subsets: ['latin'],
    display: 'swap'
})

const hankenGrotesk = Hanken_Grotesk({
    variable: '--font-heading',
    subsets: ['latin'],
    display: 'swap'
})

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className={`${inter.variable} ${hankenGrotesk.variable} h-full font-sans antialiased`}>
            <Component {...pageProps} />
        </div>
    )
}

export default App
